import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b259e068"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-iframe" }
const _hoisted_2 = { class: "modal-dialog-right" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  key: 0,
  class: "modal-header"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }

export function render(_ctx, _cache) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modals, (modal) => {
    return (_openBlock(), _createElementBlock("section", {
      class: _normalizeClass(["new-modal-right-full-page-section", `state-${modal.state}`]),
      key: modal.name,
      style: _normalizeStyle({ zIndex: modal.index })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (!modal.isHiddenNavbar)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      class: "arrow",
                      onClick: $event => (_ctx.closeModal(modal))
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-left" })
                    ], 8, _hoisted_5),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(modal.name), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(modal.component), _mergeProps(modal.props, {
                onClose: $event => (_ctx.closeModal(modal))
              }), null, 16, ["onClose"]))
            ])
          ])
        ])
      ])
    ], 6))
  }), 128))
}